<script>
  import { onMount } from 'svelte';
  import datepicker from 'js-datepicker';
  import { format } from 'date-fns';
  import { _, locale } from 'svelte-i18n';

  export let fieldName;
  export let onChange;

  onMount(() => {
    const picker = datepicker('#datePicker', {
      startDay: 1,
      respectDisabledReadOnly: true,
      customDays: ['S', 'M', 'T', 'K', 'T', 'P', 'L'],
      customMonths: ['Tammi', 'Helmi', 'Maalis', 'Huhti', 'Touko', 'Kesä', 'Heinä', 'Elo', 'Syys', 'Loka', 'Marras', 'Joulu'],
      formatter: (input, date, instance) => {
        input.value = format(date, 'd.M.yyyy')
      },
      onSelect: (instance, date) => {
        onChange(date);
      },
      startDate: new Date()
    });
  });

function onChanges(event) {
  console.log('EVENTT')
  console.log('onchanges', event);
}
</script>
<input class="datePicker" name={fieldName} placeholder="{$_('common.choose_date')}" type="text" id="datePicker" lang="{$locale}" aria-label="{$_('common.choose_date')}">
